import { render, staticRenderFns } from "./SingleVariant.vue?vue&type=template&id=27cb5358&"
import script from "./SingleVariant.vue?vue&type=script&lang=js&"
export * from "./SingleVariant.vue?vue&type=script&lang=js&"
import style0 from "./SingleVariant.vue?vue&type=style&index=0&id=27cb5358&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports